export default class ValidatorFunctions {
    /**
     * Validates if the given value is in an "empty" state.
     * TODO: What about numbers?
     * @param value
     * @returns {boolean}
     */
    static isEmpty(value) {
        if (value instanceof Object) {
            return Object.keys(value).length === 0 || value == null
        }

        if (value instanceof Array) {
            return value.length === 0
        }

        return value === '' || value === undefined || value == null
    }
}
